"use client";

// SignInEntryButton — compact auth toggle for public pages.
// Modal sign-in: user stays on the current page after auth.
// afterSignOutUrl preserves the current path so they return here after sign-out.

import { usePathname } from "next/navigation";
import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/nextjs";

export default function SignInEntryButton() {
  const pathname = usePathname();

  return (
    <>
      <SignedIn>
        <UserButton afterSignOutUrl={pathname ?? "/"} />
      </SignedIn>
      <SignedOut>
        <SignInButton mode="modal">
          <button
            style={{
              fontSize: 13,
              padding: "5px 14px",
              border: "1px solid #ccc",
              borderRadius: 6,
              background: "#fff",
              cursor: "pointer",
              color: "#333",
            }}
          >
            ログイン
          </button>
        </SignInButton>
      </SignedOut>
    </>
  );
}
